import { Button, Stack, Text } from '@components/ui';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

interface HireCancelDialogProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export const HireCancelDialog = ({
  open,
  onStay,
  onLeave,
}: HireCancelDialogProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onStay}
      aria-labelledby="hire-cancel-title"
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          backgroundImage: 'none',
          border: 1,
          borderColor: 'divider',
          borderRadius: 3,
          width: '100%',
          maxWidth: 400,
          m: 2,
          p: 3,
        },
      }}
    >
      <Stack gap="sm">
        <Text
          id="hire-cancel-title"
          variant="subtitle"
          sx={{ fontWeight: 700 }}
        >
          {t('hire.flow.cancelTitle')}
        </Text>
        <Text variant="body" tone="muted" sx={{ fontSize: 14 }}>
          {t('hire.flow.cancelBody')}
        </Text>
      </Stack>
      <Stack direction="row" gap="md" sx={{ mt: 3 }}>
        <Button variant="secondary" sx={{ flex: 1 }} onClick={onLeave}>
          {t('hire.flow.leave')}
        </Button>
        <Button variant="primary" sx={{ flex: 1 }} onClick={onStay} autoFocus>
          {t('hire.flow.keepEditing')}
        </Button>
      </Stack>
    </Dialog>
  );
};
